import React, { Component } from 'react';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.css';
import { Toolbar } from 'primereact/toolbar';
import { AutoComplete } from 'primereact/autocomplete';
import axios from 'axios';

import './components/DocTree';
import './components/UdtDetails';
import UdtDetails from './components/UdtDetails';
import DocTree from './components/DocTree';

import SplitPane from 'react-split-pane'
import {ScrollPanel} from 'primereact/scrollpanel';

class App extends Component {

  constructor() {
    super();
    this.state = {
      udtNameSuggestions: null
    };

    axios.get('assets/schemas/AllUdts.json').then((response) => {
      let allUdts = response.data;
      let results = Object.values(allUdts.udts).map(e => e.FullyQualifiedName);

      this.setState({ allUdtNames: results });
    });
  }

  suggestUdtNames(event) {
    let results = this.state.allUdtNames.filter((u) => {
      return u.toLowerCase().includes(event.query.toLowerCase());
    });

    this.setState({ udtNameSuggestions: results });
    console.log(this.state)
  }

  componentDidMount() {
    // hackery to change the style of the div we have no direct reference to
    let udthierarchy = document.getElementById( "udthierarchy" ).parentElement;
    udthierarchy.setAttribute("style","width:auto")

    let toolbarh = document.getElementById( "docstoolbar" ).style.height;
    let splitpane = udthierarchy.parentElement;

    let h = window.innerHeight;

    // adjust the splitpane height
    let curr = splitpane.getAttribute('style')
    curr = curr.replace("100%", ( h - toolbarh - 60 ) + "px")
    splitpane.setAttribute("style", curr )
  }

  handleUdtSearch(e) {
    this.setState({ udtSearchSelectedName: e.value })
    if (this.state.allUdtNames.includes(e.value)) {
      this.state.udtDetailsComp.load(e.value)
    }
  }

  render() {
    return (
      <div>
        <Toolbar id="docstoolbar">
          <img src={require('./alfa-logo-blue-sm.png')} alt="alfa-logo" className="p-toolbar-group-left toolbar-logo" />


          <div className="p-toolbar-group-left">
            <AutoComplete
              value={this.state.udtSearchSelectedName}
              onChange={(e) => this.handleUdtSearch(e)}
              delay={200}
              placeholder="Start typing name of a data type"
              suggestions={this.state.udtNameSuggestions}
              completeMethod={this.suggestUdtNames.bind(this)} />
          </div>
        </Toolbar>

        <div >
          <SplitPane split="vertical" >
              <div id='udthierarchy'>
              <ScrollPanel style={{ height:'100vh'}}>
              {
                this.state.udtDetailsComp ?  ( 
                <DocTree 
                  udtDetailsComp = {this.state.udtDetailsComp} 
                  allUdtNames={this.state.allUdtNames}>
                </DocTree> ) : ( <p>Loading...</p> )
              }
              </ScrollPanel>
              </div>


              <div>
                  {
                    this.state.allUdtNames ?
                    (
                    <ScrollPanel style={{ height:'92vh'}}>
                        <UdtDetails
                            ref={ self => {
                                if (!this.state.udtDetailsComp)
                                    this.setState({ udtDetailsComp: self })
                                }
                            }
                            typeName={this.state.allUdtNames[0]}
                            allUdtNames={this.state.allUdtNames}>
                        >
                        </UdtDetails>
                    </ScrollPanel>
                    ) : ( <p>Loading...</p> )
                  }
              </div>

          </SplitPane>
        </div>
      </div>
    );
  }
}

export default App;
